import { useState, useEffect } from 'react';

interface ScrollPosition {
  x: number;
  y: number;
}

interface UseScrollPositionOptions {
  throttle?: number;
}

export function useScrollPosition(options: UseScrollPositionOptions = {}) {
  const { throttle = 100 } = options;
  const [scrollPosition, setScrollPosition] = useState<ScrollPosition>({ x: 0, y: 0 });

  useEffect(() => {
    let timeoutId: number | null = null;

    const handleScroll = () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }

      timeoutId = window.setTimeout(() => {
        setScrollPosition({
          x: window.scrollX,
          y: window.scrollY
        });
      }, throttle);
    };

    // Set initial position
    setScrollPosition({
      x: window.scrollX,
      y: window.scrollY
    });

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [throttle]);

  return scrollPosition;
}